import { render, staticRenderFns } from "./BuildingsOverviewPage.vue?vue&type=template&id=4a6080bd&scoped=true&"
import script from "./BuildingsOverviewPage.vue?vue&type=script&lang=js&"
export * from "./BuildingsOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./BuildingsOverviewPage.vue?vue&type=style&index=0&id=4a6080bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6080bd",
  null
  
)

export default component.exports